import { SuspenseSelect } from '@/components/Suspense';
import { useGetInvoiceReportStatuses } from '@/context/services/reportsType/invoiceReports/Edit.service';
import { InvoiceReportsSearchFormData } from '@/features/invoice_reports/components/Search/hooks/useSearchForm';
import { PropsControl } from '@/features/invoice_reports/components/Search/type';
import { FormSelect, SelectProps } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

const _InvoiceStatusesSelect: FC<PropsControl> = memo(
  ({ control, name, labelProps }) => {
    const { data } = useGetInvoiceReportStatuses(false);
    const memoizedStatuses = useMemo(() => {
      return (
        data?.data?.map((status) => ({
          label: status.name ?? '',
          value: status.value ?? '',
        })) ?? []
      );
    }, [data?.data]);

    const selectProps: SelectProps = useMemo(
      () => ({
        options: memoizedStatuses,
        label: labelProps,
        size: 'small',
      }),
      [memoizedStatuses, labelProps]
    );

    return (
      <FormSelect<InvoiceReportsSearchFormData>
        control={control}
        name={name}
        inputId={name}
        testId={name}
        selectProps={selectProps}
      />
    );
  }
);

_InvoiceStatusesSelect.displayName = '_InvoiceStatusesSelect';

export const InvoiceStatusesSelect: FC<PropsControl> = memo((props) => (
  <SuspenseSelect>
    <_InvoiceStatusesSelect {...props} />
  </SuspenseSelect>
));

InvoiceStatusesSelect.displayName = 'InvoiceStatusesSelect';
